<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="80">
      <FormItem label="菜单类型" prop="menuType">
        <sl-select dict="menuType" type="radio" v-model="form.menuType" />
      </FormItem>
      <FormItem label="菜单名称" prop="name">
        <Input type="text" v-model="form.name"></Input>
      </FormItem>
      <FormItem label="链接地址" prop="url">
        <Input type="text" v-model="form.url"></Input>
      </FormItem>
      <FormItem label="菜单编码" prop="code">
        <Input type="text" v-model="form.code"></Input>
      </FormItem>
      <FormItem label="上级菜单" prop="parentId">
        <sl-select v-model="form.parentId" :dict="menus" :filterable="true" />
      </FormItem>
      <FormItem label="关联模块" prop="modelIds">
        <sl-select v-model="form.modelIds" :dict="modules" :filterable="true" :multiple="true" />
      </FormItem>
      <FormItem label="菜单排序" prop="orderIndex" style="text-align: left;">
        <InputNumber v-model="form.orderIndex"></InputNumber>
      </FormItem>
      <FormItem label="菜单描述" prop="remark">
        <Input type="textarea" :autosize="{minRows: 5,maxRows: 8}" v-model="form.remark"></Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </sl-side-panel>
</template>
<script>
export default {
  data() {

    return {
      rules: {
        name: [
          { required: true, message: '请输入菜单名称', trigger: 'blur,change' },
        ],
        code: [
          { required: true, message: '请输入菜单编码', trigger: 'blur,change' },
        ],
        menuType:[
          { required: true,type:'number', message: '请选择菜单类型', trigger: 'blur,change' },
        ],
      },
      form: {
        id: null,
        name: '',
        url: '',
        code: '',
        orderIndex: 1,
        parentId:null,
        menuType:null,
        remark: null,
        modelIds:[]
      },
      id: null,
      loading: false,
      isCreate: true,
      modalVisible: false,
    }
  },

  created() {
    this.def = { ...this.form }
  },
  computed: {
    itemTitle() {
      return this.id ? '编辑菜单' : '新增菜单'
    },
    menus(){
      return this.$request.menuQueryAll().then(resp => {
        return Promise.resolve(resp.data.map(i => ({value:i.id , label:i.name+'('+i.id+')'})))
      })
    },
    modules(){
      return this.$request.moduleSelect().then(resp => {
        return Promise.resolve(resp.data.map(i => ({value:i.id , label:i.name})))
      })
    }
  },

  methods: {
    query() {
      this.$request.menu(this.id).then(resp => {
        this.$utils.fill(this.form, resp.data)
      })
    },

    init(id, isCreate) {
      this.id = id
      this.reset()
      this.modalVisible = true

      if (this.id) {
        this.query()
      }

    },
    create(data) {
      this.modalVisible = true

      this.reset()

      this.form.parentId = data.id
    },
    edit(data) {
      this.modalVisible = true

      this.reset()

      this.$utils.fill(this.form, data)
    },
    reset() {
      this.$utils.fill(this.form, this.def)
      this.$refs['form'].resetFields()
    },

    save() {
      //
      let params = { ...this.form }
      if( params.parentId == 0) delete params.parentId

      let promise = params.id ? this.$request.menuUpdate : this.$request.menuCreate
      this.loading = true

      promise(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('保存成功')
          this.$emit('on-update')
          this.modalVisible = false
        }
        this.loading = false
      })

    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },
    handleClose() {
      this.$emit('on-update')
    }
  }
}

</script>
